// Defina e exporte suas constantes
export const PROFILE_ROOT = 'Root';
export const PROFILE_ADMIN = 'Admin';
export const PROFILE_API = 'Api';
export const PROFILE_WEB = 'Web';
export const PROFILE_APIWEB = 'Api+Web';

export const PROFILE_ROOT_ID = 0;
export const PROFILE_ADMIN_ID = 1;
export const PROFILE_API_ID = 2;
export const PROFILE_WEB_ID = 3;
export const PROFILE_APIWEB_ID = 4;